import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Process from './ExpandProcess';

class ExpandFamily extends React.Component {

    state = {
        expand: true
    }

    render() {
        const { family, hide } = this.props;
        const { expand } = this.state;

        return (
            <div
                key={randomstring()}
                className="flex_auto_column margin_bottom_12">
                <div className="flex_auto_row padding_borders_flat bg_light-purple c_slate uppercase margin_bottom_12 center">
                    {expand
                        ? <ExpandLess className="hand c_white" onClick={() => { this.setState({expand: !expand }) }} />
                        : <ExpandMore className="hand c_white" onClick={() => { this.setState({expand: !expand }) }} />
                    }
                    <span className="margin_right_12 flex_full_row c_white">{family.nombre}</span>
                </div>
                {expand && family.procesos.map((p) => 
                        <Process {...this.props} 
                                key={randomstring()} 
                                hide={hide}
                                process={p}    
                                />
                )}
            </div>
        )
    }
}

ExpandFamily.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ExpandFamily);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/ExpandFamily.js